import script from "./EstatusWhatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./EstatusWhatsapp.vue?vue&type=script&setup=true&lang=js"

import "./EstatusWhatsapp.vue?vue&type=style&index=0&id=6939fba9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6939fba9"]])

export default __exports__